/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20.2288.1155a.7553.7553 0 0 1 .833.4915l.0339.132 1.1554 7.0713-7.0702 1.1537a.755.755 0 0 1-.3752-1.4566l.132-.0339 5.5733-.9105a.756.756 0 0 1-.1112-.1527C18.1276 2.2997 13.0573.6004 8.7487 2.544 5.8477 3.8526 3.9093 6.4235 3.483 9.4401a.755.755 0 0 1-.8533.642.755.755 0 0 1-.642-.8533c.499-3.5305 2.7683-6.5404 6.14-8.0614 4.1214-1.859 8.8395-.8616 11.867 2.2019L19.6053.9825a.7553.7553 0 0 1 .4915-.8331l.132-.0339Zm-4.8865 21.1934c-4.2996 1.9395-9.359.2517-11.638-3.8427a.7583.7583 0 0 0-.1034-.1435l4.566-.7459.132-.0339a.7553.7553 0 0 0-.3752-1.4566L.8534 16.24l1.1554 7.0714.034.1319a.7552.7552 0 0 0 .833.4915l.132-.0339a.7553.7553 0 0 0 .4914-.8331l-.677-4.1494c2.8298 4.2531 8.3837 5.9131 13.1411 3.7671 3.3028-1.4898 5.5651-4.5265 6.1046-8.0412a.7552.7552 0 0 0-1.4927-.2291c-.4628 3.0145-2.4011 5.6164-5.2329 6.8937Z"
    clipRule="evenodd"
  />,
  'Reload'
);
